import React, { useState, useEffect, Fragment } from "react";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { FaCaretDown } from "react-icons/fa";
import { connect } from "react-redux";
import styled from "styled-components";
import _ from "lodash";
import ReactTooltip from "react-tooltip";
import { MdHelp} from "react-icons/md";

const SavDropToggle = styled.div`
  background-color: ${(props) =>
    props.style ? props.style.backgroundColor : "#f9f9f9"};
  padding: ${(props) => (props.style ? props.style.padding : "8px")}
  color: ${(props) => (props.style ? props.style.color : "#f9f9f9")};
  width: ${(props) => (props.style ? props.style.width : "100%")};
  height: ${(props) => (props.style ? props.style.height : "auto")}
  border: ${(props) => (props.style ? props.style.border : "none")}
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  min-height:28px;
  padding:5px;
`;

const dropStyle = {
  backgroundColor: "#fff",
  border: "1px solid #979797",
  color: "#3f3f3f",
  padding: 10,
  marginBottom: 10
}

const SavLabel = styled.span`
  font-family:"Gotham-Medium";
  font-size:12px;
  color:#979797;
`;

const SavHeader = styled.div`
  font-family:"Gotham-Medium";
  font-size:16px;
  color:#3f3f3f;
`;


const LicenseOption = ({option, optionLevels, setOptionLevels, uploadData, }) => {
  const [optionValue, setOptionValue] = useState(option.options[0].label);
  const [hide, setHide] = useState(false);

  // useEffect(() => {

  //   if (option.hiddenDependency){
  //     if (option.hiddenDependency.values.includes(optionLevels[option.hiddenDependency.label])){
  //       setHide(true);
  //       setOptionValue(option.options[0].label)
  //       // const tempObj = {...optionLevels};
  //       // tempObj[option.label] = option.options[0].hostLevel;
  //       // setOptionLevels(tempObj);
  //     } else {
  //       setHide(false);
  //     }
  //   }
  // },[optionLevels,option.hiddenDependency, option.options])

  useEffect(() => {
    if (uploadData) {
  
      setOptionValue(uploadData[option.label]);
  
      setOptionLevels((prevOptionLevels) => {
        const tempObj = { ...prevOptionLevels };
  
        const optionFound = _.find(option.options, (o) => o.label === uploadData[option.label]);
        if (optionFound) {
          tempObj[option.label] = optionFound.hostLevel;
        }
        return tempObj;
      });
    }
  }, [uploadData, option.options, option.label, setOptionLevels]);

  const handleClick = (o) => {
    setOptionValue(o.label);
    const tempObj = {...optionLevels};
    tempObj[option.label] = o.hostLevel;
    setOptionLevels(tempObj);
  }

  const renderTooltip = () => {
    if (option.helpText){
      return (
        <div>
          <ReactTooltip id={option.label} className="tooltip-issuetype" effect='solid'>
          <p className="wht" style={{paddingTop: 15, maxWidth: 200}}>{option.helpText}</p>
        </ReactTooltip>
      
          <MdHelp size={16}
            style={{ color: "#fff", cursor: 'help' }}
            data-tip data-for={option.label}
            />
        </div>
      )
    }
    return null;
  }
  if (!hide){
    return (
      <Col md={6} lg={4}>
        <SavLabel style={{display:"flex", justifyContent: "space-between", alignItems:'end'}}>{option.label}{renderTooltip()}</SavLabel>
        <Dropdown className="savDrop">
          <Dropdown.Toggle id="dropdown-basic" as="div">
            <SavDropToggle style={dropStyle}>
              <span>{optionValue}</span>
              <FaCaretDown />
            </SavDropToggle>
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ width: "100%" }}>
            {option.options.map((o) => {
              return (
                <Dropdown.Item
                  as="div"
                  href="#"
                  key={o.label}
                  name={o.label}
                  onClick={() => handleClick(o)}
                  className="onHov"
                  style={{ borderBottom: "1px solid #DBD9D6" }}
                >
                  <span style={{ display: "inline-flex" }}>{o.label}</span>
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    );
  }
  return null;
  
};

const mapStateToProps = state => {
  return {
    state: null
  };
};
export default connect(mapStateToProps)(LicenseOption);